import type {
  GuidanceTooltipSchemaType,
  Modification,
} from '@carboncopyco/types';
import { RulesContent } from '../RulesManager';
import { GuidanceManagerSectionHeader } from './GuidanceManagerSectionHeader';
import { GuidanceTooltipsRuleListItem } from './GuidanceTooltipsRuleListItem';

type Rule = Modification<GuidanceTooltipSchemaType.guidanceTooltip>;
interface Props {
  url: string;
  guidanceTooltipModifications: Rule[];
  pageUrl: string;
  onToggleVisibility: (rule: Rule, isVisible: boolean) => void;
  onDelete: (rule: Rule) => void;
  onItemHover: (rule: Rule) => void;
  onItemUnhover: (rule: Rule) => void;
  onItemClick: (rule: Rule) => void;
  onSetGlobal?: (edit: Rule, isGlobal: boolean) => void;
}

export const GuidanceTooltipsManagerSection = ({
  url,
  guidanceTooltipModifications,
  pageUrl,
  onDelete,
  onToggleVisibility,
  onItemHover,
  onItemUnhover,
  onItemClick,
  onSetGlobal,
}: Props) => {
  return (
    <div
      className="hidden [&:has(:nth-child(2))]:block"
      id="guidance-manager-section"
    >
      <GuidanceManagerSectionHeader label={url} />
      <RulesContent.List<
        Modification<GuidanceTooltipSchemaType.guidanceTooltip>
      >
        rules={guidanceTooltipModifications.map((rule) => ({
          id: rule.id,
          rule,
        }))}
        renderItem={({ ruleItem }) => (
          <GuidanceTooltipsRuleListItem
            rule={ruleItem.rule}
            onDelete={onDelete}
            onToggleVisibility={onToggleVisibility}
            onItemHover={onItemHover}
            onItemUnhover={onItemUnhover}
            pageUrl={pageUrl}
            onClick={onItemClick}
            onSetGlobal={onSetGlobal}
          />
        )}
      />
    </div>
  );
};
